import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes conditionally, deduplicating conflicting utilities.
 * Usage: `cn('px-4 py-2', isActive && 'bg-primary', className)`
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
